exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".largeIframe{position:absolute;left:0}.iframe-cont{width:100%;position:relative;margin-bottom:70px;min-height:100%}.iframe-cont iframe.resource__iframe{margin-left:auto;margin-right:auto}", ""]);

// exports
